import { __ } from "@wordpress/i18n";
export const features = [
	{ name: __( '24/7 Premium Support', 'astra' ) },
	{ name: __( 'Access To Pro Updates', 'astra' ) },
	{ name: __( 'CSS File Generation For Speed Optimization', 'astra' ) },
	{ name: __( 'White Label', 'astra' ) },
	{ name: __( 'Page Background Styling', 'astra' ) },
	{ name: __( 'Sidebar Designing Styles', 'astra' ) },
	{
		name: __( 'Colors and Backgrounds', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{
		name: __( 'Typography', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{
		name: __( 'Spacing', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{ name: __( 'Full Width Site Layout', 'astra' ) },
	{ name: __( 'Max Width Site Layout', 'astra' ) },
	{ name: __( 'Padded Site Layout', 'astra' ) },
	{ name: __( 'Fluid Site Layout', 'astra' ) },
	{ name: __( 'Multiple Page Headers', 'astra' ) },
	{ name: __( 'Custom Header', 'astra' ) },
	{ name: __( 'Custom Footer', 'astra' ) },
	{ name: __( 'Custom 404 Page', 'astra' ) },
	{ name: __( 'Hooks Support to Add Custom Code', 'astra' ) },
	{ name: __( 'Sticky When Scroll Up', 'astra' ) },
	{ name: __( 'Shrink When Scroll Up', 'astra' ) },
	{ name: __( 'Hide Sticky When Scroll Down', 'astra' ) },
	{ name: __( 'Sticky Header Animations', 'astra' ) },
	{ name: __( 'Mega Menu', 'astra' ) },
	{ name: __( 'Multiple HTML Elements', 'astra' ) },
	{ name: __( 'Multiple Button Elements', 'astra' ) },
	{ name: __( 'Divider Elements', 'astra' ) },
	{ name: __( 'Color & Typography Options', 'astra' ) },
	{ name: __( 'Archive Page - Post Content Layouts', 'astra' ) },
	{ name: __( 'Archive Page - Post Grid Control', 'astra' ) },
	{ name: __( 'Archive Page - Post Readtime Meta Option', 'astra' ) },
	{ name: __( 'Single Post Page - Post Readtime Meta Option', 'astra' ) },
	{ name: __( 'Single Post Page - Author Info Box', 'astra' ) },
	{ name: __( 'Single Post Page - Post Navigation Visibility Control', 'astra' ) },
	{ name: __( 'Breadcrumbs Shortcode', 'astra' ) },
	{ name: __( 'Search Box Shortcode', 'astra' ) },
	{ name: __( 'WooCommerce Mini-Cart Shortcode', 'astra' ) },
	{ name: __( 'EDD Mini-Cart Shortcode', 'astra' ) },
	{
		name: __( 'WooCommerce', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{
		name: __( 'LifterLMS', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{
		name: __( 'LearnDash', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
	{
		name: __( 'Easy Digital Downloads', 'astra' ),
		free: __( 'Limited Features', 'astra' ),
		pro: __( 'All Features', 'astra' ),
	},
].map( ( feature ) => ( {
	...feature,
	free: feature.free || 'no',
	pro: feature.pro || 'yes',
} ) );

